var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-info"},[_c('id-validate',{attrs:{"all-data":_vm.allData,"card-type-list":_vm.cardTypeList},on:{"ajax-success":_vm.ajaxSuccess}}),_c('address-validate',{attrs:{"all-data":_vm.allData},on:{"ajax-success":_vm.ajaxSuccess}}),_c('investment-experience',{attrs:{"all-data":_vm.allData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }